export var CONTENT_WIDTH = 1000;
